import React from 'react';
import Head from 'next/head';
import { ContentfulImage } from '../../util/types';

export interface MetaProps {
  title?: string,
  baseURL?: string,
  image?: ContentfulImage,
  twitter_user?: string,
  description?: string,
  locale?: string,
  children?: React.ReactNode,
  pathname?: string,
  noindex?: boolean,
  nofollow?: boolean,
}

export default function Meta({
  title,
  baseURL,
  image,
  twitter_user,
  description,
  locale,
  children,
  noindex,
  nofollow,
  pathname,
}: MetaProps) {
  return (
    <Head>
      {title && <title>{title}</title>}
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width,initial-scale=1.0" />
      {description && <meta name="description" content={description} />}
      <meta name="theme-color" content="#3f2a56" />
      {locale && <meta httpEquiv="Content-Language" content={(locale || 'en-US').replace('-', '_')} />}
      <link rel="canonical" href={`${baseURL || 'https://itero-lab-locator-staging.herokuapp.com'}${pathname}`} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image?.fields.file.url} />}
      {baseURL && <meta property="og:url" content={baseURL} />}
      {title && <meta property="og:site_name" content={title} />}
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image?.fields.file.url} />}
      {twitter_user && <meta name="twitter:site" content={twitter_user} />}
      {twitter_user && <meta name="twitter:creator" content={twitter_user} />}
      {(noindex || nofollow) && <meta name="robots" content="noindex,nofollow" />}
      {children}
    </Head>
  );
}

Meta.displayName = '@ioa/lablocator/Meta';
